export const Labels = () => (
  <div
    style={{
      display: 'grid',
      fontSize: '10px',
      gridTemplateColumns: '5fr 8fr 5fr 12fr',
      breakInside: 'avoid',
    }}
  >
    <div
      style={{
        display: 'grid',
        gridTemplateRows: 'repeat(4, 1fr)',
      }}
    >
      <div
        style={{
          gridRow: '1 / span 4',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          fontWeight: 'bold',
          padding: '0px 5px',
        }}
      >
        Legenda <br />(Grau de Severidade):
      </div>
    </div>

    <div
      style={{
        display: 'grid',
        gridTemplateRows: 'repeat(4, 1fr)',
      }}
    >
      <div
        style={{
          display: 'flex',
          padding: '4px',
        }}
      >
        <strong>Conforme</strong>
      </div>
      <div
        style={{
          display: 'flex',
          padding: '4px',
        }}
      >
        <strong>Não Conforme (NC)</strong>
      </div>
      <div
        style={{
          display: 'flex',
          padding: '4px',
        }}
      >
        <strong>Alta (14.0)</strong> - Paralisa Atividade
      </div>
      <div
        style={{
          display: 'flex',
          padding: '4px',
        }}
      >
        <strong>Média (12.0)</strong> - Providenciar Correção
      </div>
    </div>

    <div
      style={{
        display: 'grid',
        gridTemplateRows: 'repeat(4, 1fr)',
      }}
    >
      <div
        style={{
          display: 'flex',
          padding: '4px',
        }}
      >
        <strong>Baixa (11.0)</strong> - Propor Melhorias
      </div>
    </div>

    <div
      style={{
        display: 'grid',
        gridTemplateRows: 'repeat(1, 1fr)',
      }}
    >
      <div
        style={{
          gridRow: '1 / span 4',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          fontWeight: 'bold',
          padding: '0px 5px',
        }}
      >
        Observações: Em caso de não conformidades, detalhar nas observações o plano de ação sugerido.
      </div>
    </div>
  </div>
);
